import { startCase, toString } from 'lodash';

/* eslint-disable @typescript-eslint/no-explicit-any */
function isPlainObject(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function deepObject(oldObj: any, newObj: any, path = '') {
  const result: Record<string, { old: any; new: any }> = {};

  const oldIsArr = Array.isArray(oldObj);
  const newIsArr = Array.isArray(newObj);

  // Handle arrays at this level
  if (oldIsArr || newIsArr) {
    const oldArr = oldIsArr ? oldObj : [];
    const newArr = newIsArr ? newObj : [];
    const max = Math.max(oldArr.length, newArr.length);

    for (let i = 0; i < max; i++) {
      const oItem = oldArr[i];
      const nItem = newArr[i];
      const itemPath = `${path}[${i}]`;

      // If either side is an object or array, recurse
      if (
        (oItem && (isPlainObject(oItem) || Array.isArray(oItem))) ||
        (nItem && (isPlainObject(nItem) || Array.isArray(nItem)))
      ) {
        const nested = deepObject(oItem, nItem, itemPath);
        Object.assign(result, nested);
      } else if (!Object.is(oItem, nItem)) {
        result[itemPath] = { old: oItem, new: nItem };
      }
    }

    return result;
  }

  // Handle plain objects at this level
  const allKeys = new Set([...Object.keys(oldObj || {}), ...Object.keys(newObj || {})]);

  for (const key of allKeys) {
    const oldVal = oldObj?.[key];
    const newVal = newObj?.[key];
    const currentPath = path ? `${path}.${key}` : key;

    const oldValIsArr = Array.isArray(oldVal);
    const newValIsArr = Array.isArray(newVal);

    if (
      (oldVal && (isPlainObject(oldVal) || oldValIsArr)) ||
      (newVal && (isPlainObject(newVal) || newValIsArr))
    ) {
      const nested = deepObject(oldVal, newVal, currentPath);
      Object.assign(result, nested);
    } else if (!Object.is(oldVal, newVal)) {
      result[currentPath] = { old: oldVal, new: newVal };
    }
  }

  return result;
}

export function fieldPathToLabel(path: any) {
  const str = toString(path);
  const parts = str.split('.');

  const labelParts = parts.map((p) => {
    const match = p.match(/(\w+)\[(\d+)\]/);

    if (match) {
      const key = match[1];
      const index = Number(match[2]) + 1; // 0 → 1
      return `${startCase(key)} #${index}`;
    }

    return startCase(p);
  });

  return labelParts.join(' – ');
}

export function deepDiff(oldObj: any, newObj: any, path = '') {
  const result = deepObject(oldObj, newObj, path);
  return Object.entries(result).map(([field, value]) => ({
    field,
    old: value.old,
    new: value.new
  }));
}
